import CustomTooltip from '../../../../../shared/CustomTooltip';
import { Add, KeyboardArrowDown } from '@mui/icons-material';
import { Button, Paper, Typography } from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import React from 'react';
import FormAutocomplete from '../../../../../shared/FormAutocomplete';
import CustomInputLabel from '../../../../../../layout/styledcomponents/CustomInputLabel';

type Props = {
    isGuestAdmin: boolean;
    control: any;
    isFetchingGuestUsers: boolean;
    guestUsers: Array<{
        id: string;
        firstName: string;
        lastName: string;
        email: string;
        isActive: boolean;
    }>;
    navigate: (to: string, opts?: any) => void;
    bookerId?: string;
};

export default function BookerSelect({
    isGuestAdmin,
    control,
    isFetchingGuestUsers,
    guestUsers,
    navigate,
    bookerId,
}: Props) {
    if (!isGuestAdmin) return null;

    return (
        <div>
            <CustomInputLabel
                required={!bookerId}
                htmlFor='booker-select__input'
                id='booker-select__label'
            >
                Who is this reservation for?{' '}
                <CustomTooltip
                    title={
                        <Typography>
                            If you make a reservation on behalf of someone else,
                            they will appear as the booker and you will both
                            receive notifications for the reservation.
                        </Typography>
                    }
                    placement='right'
                >
                    <HelpOutlineIcon
                        sx={{
                            color: 'primary.main',
                            fontSize: '14px',
                        }}
                    />
                </CustomTooltip>
            </CustomInputLabel>
            <FormAutocomplete
                id='booker-select__input'
                name='booker.id'
                control={control}
                loading={isFetchingGuestUsers}
                PaperComponent={({ children }: any) => (
                    <Paper>
                        <Button
                            fullWidth
                            size='large'
                            sx={{
                                justifyContent: 'flex-start',
                                pl: 2,
                                mt: 1,
                                fontSize: '14px',
                            }}
                            startIcon={<Add />}
                            onMouseDown={() =>
                                navigate(`/newUser`, {
                                    state: { name: 'newUser' },
                                })
                            }
                        >
                            Create New User
                        </Button>
                        {children}
                    </Paper>
                )}
                options={
                    isFetchingGuestUsers
                        ? []
                        : guestUsers
                              .filter((u) => u.isActive)
                              .map((u) => ({
                                  value: u.id,
                                  label: `${u.firstName} ${u.lastName} (${u.email})`,
                              }))
                }
                popupIcon={<KeyboardArrowDown />}
            />
        </div>
    );
}
